// Client-side amenity mapping — mirrors the backend `_AMENITY_ALIASES`
// used by /api/locations so the same filter chips can either post to
// the server OR (as of now on Discover/Map) filter the already-loaded
// list of trails instantly with zero re-fetch.
//
// Extend by adding a new key + tag aliases + lucide meta. No route/
// backend changes needed — the tags below match the OSM-sourced values
// already present in each trail's `dog_amenities` array.
import { Trees, Droplets, Utensils } from "lucide-react";

export const AMENITY_KEYS = ["shaded", "water_tap", "picnic_area"];

// OSM dog_amenities tag values that satisfy each filter key.
export const AMENITY_ALIASES = {
  shaded: ["shade", "shaded_paths"],
  water_tap: ["water_tap", "water_bowls", "water_access", "streams_for_drinking"],
  picnic_area: ["picnic_area", "picnic_tables", "picnic"],
};

// UI metadata (label + lucide icon) — used by LocationDetail badges,
// the Discover Filters sheet, and the Map amenity chips.
export const AMENITY_META = {
  shaded: { label: "Shaded", Icon: Trees },
  water_tap: { label: "Water Tap", Icon: Droplets },
  picnic_area: { label: "Picnic Area", Icon: Utensils },
};

// Cheap set-lookup: does the trail satisfy the requested amenity key?
export function trailMatchesAmenity(loc, key) {
  const aliases = AMENITY_ALIASES[key];
  if (!aliases) return true;
  const tags = loc?.dog_amenities;
  if (!Array.isArray(tags) || tags.length === 0) return false;
  return aliases.some((a) => tags.includes(a));
}

// Composes AND semantics across multiple selected keys.
export function trailMatchesAllAmenities(loc, keys) {
  if (!keys || keys.length === 0) return true;
  return keys.every((k) => trailMatchesAmenity(loc, k));
}

// Returns the ordered list of amenity keys present on a given trail —
// used by LocationDetail to render badges only for what's actually there.
export function trailAmenityKeys(loc) {
  return AMENITY_KEYS.filter((k) => trailMatchesAmenity(loc, k));
}
